import React from "react";
import LegalPage from "./LegalPage";

export default function Terms() {
    return (
        <LegalPage
            testid="page-terms"
            title="Terms of Service"
            subtitle="The terms under which enterprise customers and their authorised users access AudRI."
            lastUpdated="21 April 2026"
        >
            <p>
                These Terms of Service ("Terms") govern access to and use of the
                AudRI platform. By creating an account or accepting an invitation,
                you agree to these Terms on behalf of the organisation that you
                represent.
            </p>

            <h2>1. Service</h2>
            <p>
                AudRI provides software-as-a-service for automating GxP periodic
                reviews and Computer System Validation ("CSV") audits. AudRI is a
                decision-support tool; human-in-the-loop QA approval is required
                before any output is treated as a regulatory record.
            </p>

            <h2>2. Accounts and access</h2>
            <ul>
                <li>
                    Organisations designate an Admin who manages users, roles and
                    access.
                </li>
                <li>
                    You are responsible for the confidentiality of credentials and
                    for all activity performed under them.
                </li>
                <li>
                    Access is granted per seat; sharing accounts is prohibited.
                </li>
            </ul>

            <h2>3. Acceptable use</h2>
            <p>You agree not to:</p>
            <ul>
                <li>Upload content you are not authorised to process.</li>
                <li>
                    Attempt to circumvent security, rate-limiting or audit-trail
                    controls.
                </li>
                <li>
                    Use the service to generate outputs intended to mislead regulators
                    or falsify records.
                </li>
            </ul>

            <h2>4. Customer content</h2>
            <p>
                You retain all rights in the content you upload. You grant AudRI a
                limited licence to process that content solely to provide the
                service. AudRI does not use customer content to train third-party
                foundation models.
            </p>

            <h2>5. AI outputs — no warranty of regulatory approval</h2>
            <p>
                AudRI uses large language models to extract rules, match evidence
                and draft findings. Outputs are probabilistic and may contain
                errors. Every output must be reviewed and approved by qualified
                personnel at your organisation before being used in a regulatory
                submission, inspection, or QMS record.
            </p>

            <h2>6. Confidentiality</h2>
            <p>
                Each party will protect the other's confidential information with at
                least the same degree of care it uses for its own confidential
                information, and no less than a reasonable degree of care.
            </p>

            <h2>7. Fees, term and termination</h2>
            <p>
                {"{{TODO: subscription pricing, renewal terms, termination-for-cause, effect of termination on data export.}}"}
            </p>

            <h2>8. Warranties and liability</h2>
            <p>
                {"{{TODO: warranty disclaimers and limitation of liability — to be finalised by counsel.}}"}
            </p>

            <h2>9. Governing law</h2>
            <p>
                {"{{TODO: governing law and venue — typically Delaware, England & Wales, or customer's country for EU engagements.}}"}
            </p>

            <h2>10. Contact</h2>
            <p>
                <a href="mailto:legal@audri.app">legal@audri.app</a>.
            </p>
        </LegalPage>
    );
}
